import React, { useContext } from "react";
import { GlobalContext } from "contexts/GlobalStore";

export const NavButton = (props) => {
    const { id, text, icon, onClick } = props;
    const { sidebarBehavior } = useContext(GlobalContext);

    return (
        <div
            id={id}
            // tabIndex="0"
            className={
                "sidebar_navButton " + sidebarBehavior.position + " " + sidebarBehavior.content
            }
            onMouseDown={() => {
                if (onClick) {
                    onClick();
                }
            }}
            onKeyPress={(e) => {
                if ((e.key = "Enter")) {
                    onClick();
                }
            }}
        >
            <div
                className="sidebar_navButton_wideRect"
                dangerouslySetInnerHTML={{ __html: text }}
            />
            <div className="sidebar_navButton_narrowRect">
                <img src={require(`img/${icon}`)} alt="" />
            </div>
        </div>
    );
};
